// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { spacing } from '@iheartjane/reefer-emotion';
import { Outlet } from 'react-router';

import { ProductTable } from '@jane/business-admin/components';
import { ProductsTableProvider } from '@jane/business-admin/providers';

const Wrapper = styled.div({
  display: 'flex',
  ...spacing({ px: 64, py: 40 }),
});

const Main = styled.div({
  width: '100%',
});

export const StoreProducts = () => {
  return (
    <Wrapper>
      <Main>
        <ProductsTableProvider>
          <ProductTable />
          {/* Where the details modals load */}
          <Outlet />
        </ProductsTableProvider>
      </Main>
    </Wrapper>
  );
};
